import { Link } from 'react-router-dom';
import '../../styles/home/About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Sonny Blinds</h2>
            <p className="lead">Your trusted partner for quality window treatments since 2002.</p>
            <p>
              At Sonny Blinds, we specialize in providing premium{' '}
              <Link to="/blinds">blinds</Link>,{' '}
              <Link to="/shades">shades</Link>, and{' '}
              <Link to="/shutters">shutters</Link>{' '}
              to homeowners and businesses. With over a decade of experience, we've helped thousands of customers transform their spaces with our high-quality window treatments.
            </p>
            <p>Our commitment to excellence is reflected in every aspect of our service. From the initial consultation to the final installation. We work with leading manufacturers to ensure you receive products that combine style, functionality, and durability.</p>
            <ul className="about-list">
              <li>✓ Over 30 years of industry experience</li>
              <li>✓ Thousands of satisfied customers</li>
              <li>✓ Wide selection of premium products</li>
              <li>✓ Expert installation services</li>
              <li>✓ Lifetime Warranty on blind components</li>
              <li>✓ 1-Year Warranty on motorized mechanisms</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
